import { useState, useEffect, useRef } from 'react'
import classNames from 'classnames';

import Reveal from 'reveal.js'

import styles from 'styles/CharacterSelectionScreen.module.css'
import { characterSelectionAssets } from 'assets/images/CharacterSelectionScreen'
import leftArrow from 'assets/images/common/leftArrowSecondary.svg'
import rightArrow from 'assets/images/common/rightArrowSecondary.svg'
import { sendSocketMessage } from 'config/socket/socketUtil'

type ActivityType = {
  imgSrc: string
  secondaryImgSrc: string
  avatar: string
}

type CharacterSelectionScreenProps = {
  firebaseRef: any;
  socketInstance: any;
  selectedAvatar: string;
  isTeacher: boolean;
}


function CharacterSelectionScreen({ firebaseRef, socketInstance, selectedAvatar, isTeacher } : CharacterSelectionScreenProps) {

  const slideNumberRef = useRef<number>(0)

  const leftArrowRef = useRef<any>()
  const rightArrowRef = useRef<any>()

  const [ currentSlide, setCurrentSlide ] = useState<number>(0)

  const [ showAnimation, setShowAnimation ] = useState<boolean>(false)

  const [ assets, setAssets ] = useState<ActivityType[]>(characterSelectionAssets)

  const assetRef = useRef<any>(characterSelectionAssets)

  const [ isAvatarSynced, setIsAvatarSynced] = useState<boolean>(false)

  useEffect(() => {
    if(selectedAvatar && characterSelectionAssets && !isAvatarSynced) {
      const index = assets.findIndex(asset => asset.avatar === selectedAvatar)
      if(index !== (assets.length - 1)) {
        for(let i = 0; i < (assets.length - 1 - index); i++ ) {
          let newArray = assets
          newArray.unshift(newArray.pop()!)

          // if (slideNumberRef.current + 1 < newArray.length) {
          //   slideNumberRef.current = slideNumberRef.current + 1
          //   setCurrentSlide(slideNumberRef.current)
          // }
          setAssets([...newArray])
          assetRef.current = [ ...newArray ]
          setIsAvatarSynced(true)
        }
        // const newIndex = assets.findIndex(asset => asset.avatar === selectedAvatar)
        // setCurrentSlide(newIndex)
      }
    }

  }, [ selectedAvatar])

  useEffect(() => {
    const callbackFunction = (state: any) => {
      leftArrowRef.current.className = styles.disabledArrowIcons
      rightArrowRef.current.className = styles.disabledArrowIcons
      if(state.navigateTo === 'left') {
        navigateLeft()
      } else if(state.navigateTo === 'right') {
        navigateRight()
      } else if(state.selectedAvatar){
        onSelectCharacter();
      }

      setTimeout(() => {
        leftArrowRef.current.className = slideNumberRef.current === 0 ? styles.hiddenBtn : styles.image
        rightArrowRef.current.className = slideNumberRef.current === characterSelectionAssets.length - 1 ? styles.hiddenBtn : styles.image
      }, 1200)
    }

    socketInstance.onMessage('onCharacterSlide', callbackFunction)

    // const callbackFunction = (state: any) => {
    //   if(state.sliderIndex) {
    //     setCurrentSlide(state.sliderIndex)
    //   }

    //   if(state.animateScreen) {
    //     animateScreen();
    //   }
    // }

    socketInstance.onMessage('onCharacterSlide', callbackFunction)
  },[])

  const goLeft = () => {
    navigateLeft()
    leftArrowRef.current.className = styles.disabledArrowIcons
    rightArrowRef.current.className = styles.disabledArrowIcons

    setTimeout(() => {
      leftArrowRef.current.className = slideNumberRef.current === 0 ? styles.hiddenBtn : styles.image
      rightArrowRef.current.className = slideNumberRef.current === characterSelectionAssets.length - 1 ? styles.hiddenBtn : styles.image
    }, 1200)

    sendSocketMessage({ state: { navigateTo: 'left' }, action: 'onCharacterSlide'})
  }

  const goRight = () => {
    navigateRight()

    leftArrowRef.current.className = styles.disabledArrowIcons
    rightArrowRef.current.className = styles.disabledArrowIcons

    setTimeout(() => {
      leftArrowRef.current.className = slideNumberRef.current === 0 ? styles.hiddenBtn : styles.image
      rightArrowRef.current.className = slideNumberRef.current === characterSelectionAssets.length - 1 ? styles.hiddenBtn : styles.image
    }, 1200)

    sendSocketMessage({ state: { navigateTo: 'right' }, action: 'onCharacterSlide'})
  }

  const navigateLeft = () => {
    let newArray = assetRef.current
    newArray.push(newArray.shift()!)
    const selectedAvatar = newArray[newArray?.length-1];
    firebaseRef.update({ selectedAvatar: selectedAvatar.avatar, selectedAccessories: [] })
    assetRef.current = [ ...newArray ]
    setAssets([...newArray])
    slideNumberRef.current = slideNumberRef.current - 1
    // sendSocketMessage({ state: { sliderIndex: slideNumberRef.current }, action: 'onCharacterSlide'})
    setCurrentSlide(slideNumberRef.current)
  }

  const navigateRight = () => {
    let newArray = assetRef.current
    newArray.unshift(newArray.pop()!)
    const selectedAvatar = newArray[newArray?.length-1];
    firebaseRef.update({ selectedAvatar: selectedAvatar.avatar, selectedAccessories: [] })
    assetRef.current = [ ...newArray ]
    setAssets([...newArray])
    slideNumberRef.current = slideNumberRef.current + 1
    // sendSocketMessage({ state: { sliderIndex: slideNumberRef.current }, action: 'onCharacterSlide'})
    setCurrentSlide(slideNumberRef.current)
  }

  const onClickSelect = () => {
    onSelectCharacter();
    sendSocketMessage({ state: { selectedAvatar: true }, action: 'onCharacterSlide'})
  }

  const onSelectCharacter = () => {
    // const selectedAvatar = assets[assets?.length-1];
    const selectedAvatar = assetRef.current[assetRef.current?.length - 1]
    firebaseRef.update({ selectedAvatar: selectedAvatar.avatar, selectedAccessories: [] })
    // animateScreen()
    // sendSocketMessage({ state: { animateScreen: true }, action: 'onCharacterSlide'})
    setShowAnimation(true);
    setTimeout(()=>{
      setShowAnimation(false);
      Reveal.next();
    },3000);
  }

  // const animateScreen = () => {
  //   setShowAnimation(true);
  //   setTimeout(()=>{
  //     setShowAnimation(false);
  //     Reveal.next();
  //   },3000);
  // }

  return (
    <div className={styles.container}>
      <div className={styles.slideContainer}>
        <img
          src={leftArrow}
          alt='left arrow'
          className={currentSlide === 0 ? styles.hiddenBtn : styles.image}
          onClick={goLeft}
          ref={leftArrowRef}
        />
        <div className={styles.slides}>
          <span className={classNames(styles.slideHeader)}>{assetRef.current[assetRef.current?.length - 1].avatar}</span>
            {assets.map((asset, i) => {
              return (
                  <img
                    key={`CharacterSelectionScreen${asset.avatar}`}
                    src={!showAnimation ? asset.imgSrc : asset.secondaryImgSrc}
                    className={classNames(
                      i === characterSelectionAssets.length - 1 ? styles.slideImages : styles.hidden,
                      {[styles.animationImg] : showAnimation}
                    )}
                  />
              )
            })}
        </div>
        <img
          src={rightArrow}
          alt='right arrow'
          className={currentSlide === characterSelectionAssets.length - 1 ? styles.hiddenBtn : styles.image}
          onClick={goRight}
          ref={rightArrowRef}
        />
      </div>
      <div className={classNames(styles.button)} onClick={onClickSelect}>
        SELECT
      </div>
    </div>
  )
}

export default CharacterSelectionScreen
